import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ScheduleTypeSchedule = () => {
  return (
    <SettingsMetaData propertyName={"Schedule_Type_Schedule"} viewPropertyName={"Schedule Type"} />
  );
};
export default ScheduleTypeSchedule;